export class UnsetGradingSchemeFromModuleFailure {
    static readonly type = '[GradingScheme] UnsetGradingSchemeFromModuleFailure';
}
